import type { AccessEnum, FeatureAccessWithSlug } from "generated/graphql";
import type { FeatureSlugsEnum } from "globalConstants/features";

type THasFeatureAccessParams = {
  featureSlug: FeatureSlugsEnum;
  allowedAccessTypes: AccessEnum[];
  userFeatureAccesses: FeatureAccessWithSlug[];
};

export const hasFeatureAccess = ({
  featureSlug,
  allowedAccessTypes,
  userFeatureAccesses,
}: THasFeatureAccessParams): boolean => {
  const hasAccess = userFeatureAccesses.some(
    ({ slug, type }) => slug === featureSlug && allowedAccessTypes.some(allowedType => allowedType === type),
  );

  return hasAccess;
};
